import styled from 'styled-components';
import { vw } from 'components/common/Common';
import Header from 'pages/charterQuote/components/contents/Header';

const Container = styled.div`
  width: 100%;
  height: fit-content;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: ${vw(60)};
  article {
    width: 100%;
    text-align: left;
    padding: ${vw(100)};
  }
`;

const Features = styled.div`
  width: 100%;
  height: fit-content;
  display: flex;
  justify-content: space-between;
  align-items: stretch;
  gap: ${vw(20)};
`;

const Feature = styled.div`
  width: 100%;
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: ${vw(20)};
  text-align: center;
  background: #f4f6fc;
  padding: 24px;
`;

const Title = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  justify-content: center;
`;

const TitleSpan = styled.span`
  font-size: 16px;
  font-weight: 400;
  color: #050a30;
  line-height: 1.3;
  margin: 0;
`;

const H3 = styled.h3`
  font-size: ${(props) => props.$fontSize || '32px'};
  color: #000;
  font-weight: 600;
  width: 100%;
  margin: 0 0;
`;

const Span = styled.span`
  display: block;
  font-size: ${vw(20)};
  font-weight: ${(props) => props.$weight || 400};
  line-height: 1.5;
  color: #000;
`;

const FeatureList = [
  {
    h3Title: 'Earn Up to 30% Commission',
    spanTitle: (
      <Span>Start at 10% and scale up to 30% of net profit per deal with our tiered structure</Span>
    ),
  },
  {
    h3Title: 'Recurring Revenue',
    spanTitle: (
      <Span>
        Earn commission not just once, but on every flight your client takes for up to a year.
      </Span>
    ),
  },
  {
    h3Title: 'Global Jet Access',
    spanTitle: (
      <Span>
        Provide your clients with access to more than 15,000 aircraft and on-demand routes worldwide
      </Span>
    ),
  },
  {
    h3Title: 'Affiliate Dashboard & Support',
    spanTitle: (
      <Span>
        Track your earnings, access creative assets, and one-on-one support whenever needed.
      </Span>
    ),
  },
];

const Partner = () => {
  return (
    <Container>
      <Header
        title={<>Why Partner with Airacer</>}
        desc={[
          'Private aviation demand continues to rise as travelers seek flexibility, privacy, and efficiency.',
          'With Airacer, you’ll offer clients access to 15,000+ aircraft, thousands of destinations and earn more from every trip.',
        ]}
      />
      <Features>
        {FeatureList.map((item, index) => (
          <Feature key={index}>
            <Title>
              <H3 $fontSize={'20px'}>{item.h3Title}</H3>
              <TitleSpan>{item.spanTitle}</TitleSpan>
            </Title>
          </Feature>
        ))}
      </Features>
    </Container>
  );
};

export default Partner;
